import React from "react";

const PanCardPreview = ({
  panNumber,
  fullName,
  panFrontFile,
  panFrontPreview,
  existingPanFrontUrl,
}) => {
  // Determine which image source to use
  const imageSource =
    panFrontPreview ||
    existingPanFrontUrl ||
    (panFrontFile ? URL.createObjectURL(panFrontFile) : null);

  return (
    <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-md space-y-4">
      <h2 className="text-xl font-semibold text-gray-800 mb-3">
        PAN Card Preview
      </h2>

      <div className="space-y-2 text-sm text-gray-800">
        <p>
          <strong>PAN Number:</strong> {panNumber || "N/A"}
        </p>
        <p>
          <strong>Full Name:</strong> {fullName || "N/A"}
        </p>
      </div>

      <div>
        <p className="font-semibold mb-1">PAN Front Image</p>
        {imageSource ? (
          <img
            src={imageSource}
            alt="PAN Front"
            className="w-full rounded border"
          />
        ) : (
          <p className="text-gray-500 text-sm">No front image available.</p>
        )}
      </div>
    </div>
  );
};

export default PanCardPreview;
